import { render, staticRenderFns } from "./FaqCustomSection.vue?vue&type=template&id=6b3c7995&scoped=true"
import script from "./FaqCustomSection.vue?vue&type=script&lang=js"
export * from "./FaqCustomSection.vue?vue&type=script&lang=js"
import style0 from "./FaqCustomSection.vue?vue&type=style&index=0&id=6b3c7995&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3c7995",
  null
  
)

export default component.exports